import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { toasterMessages } from "../../constants/QuestionBankConstants";
import {
  apiPaths, get, postData
} from "../../platform-components/api-integration-util";
import { Toaster } from "../../platform-components/Toaster";
import {
  getExamInfo,
  getSelectedExamInfo
} from "../../platform-components/utils/configuration";
import { getUserDetails } from "../../platform-components/utils/shared-data.service";
import "./copyexam.scss";

export default function CopyExam(props) {
  let tenantId = getUserDetails()?.tenantId;
  let { id, examname } = useParams();
  const location = useLocation(); // Get the location object
  const queryParams = new URLSearchParams(location.search);
  let [batches, setBatches] = useState([]);
  // Get branchId and batchId from the query string
  let branchIdFromQueryString = queryParams.get("branchId");
  let batchIdFromQueryString = queryParams.get("batchId");

  let [batchValue, setBatchValue] = useState(batchIdFromQueryString || "");
  let [branchValue, setBranchValue] = useState(branchIdFromQueryString || "");
  console.log('branchValue: ', branchValue);
  let [branches, setBranches] = useState([]);

  const { register, handleSubmit, watch, getValues, errors, setValue, reset } =
    useForm({
      mode: "onChange",
      reValidateMode: "onChange",
      validateCriteriaMode: "all",
    });

  useEffect(() => {
    get(apiPaths.batches, { tenantId: tenantId, branchId: branchValue }).then(
      (res) => {
        const resp = (res?.result || []).filter(
          (el) => el.branchId === +branchValue
        );
        setBatches(resp);
      }
    );
  }, [branchValue, id, tenantId]);

  useEffect(() => {
    get(apiPaths.branches, { tenantId: tenantId }).then((res) => {
      setBranches(res?.result);
    });
  }, [id, tenantId]);

  const onSaveSubmit = (formData) => {
    onSubmit(formData);
  };

  const onSubmit = (formData) => {
    if (errors && Object.keys(errors)?.length > 0 && process && process.exit) {
      process.exit(1);
    } else {
      formPayloadForCreateExam(formData);
    }
  };
  let formPayloadForCreateExam = (formData) => {
    let data = {
      newBatchId: batchValue,
      examId: +id,
      newExamName: formData?.examName,
    };

    postData(apiPaths.copyExam, {
      data,
      headers: { tenantId: tenantId, userEmail: getUserDetails().email },
    })
      .then((res) => {
        if (res?.responseCode === 200) {
          Toaster(
            toast.TYPE.SUCCESS,
            toasterMessages.SUCCESS[formData?.status]
          );
          props.history.push("/app/exams/examsInfo");
        }
      })
      .catch((e) => Toaster(toast.TYPE.ERROR, toasterMessages.FAIL.DEFAULT));
  };

  const onChangeBatch = (batchId) => {
    setBatchValue(batchId);
  };

  const onChangeBranch = (branchId) => {
    setBranchValue(branchId);
  };

  return (
    <div
      class="addquestion-main"
      style={{ display: "flex", flexDirection: "column" }}
    >
      <div className="main-heading">Copy Exam</div>
      <div className="background-common-div">
        <div class="btn-div">
          <div style={{ float: "right" }}>
            <input
              class="btn-common"
              type="button"
              value="Save"
              onClick={handleSubmit(onSaveSubmit)}
            />
          </div>
        </div>
        <div className="common-div">
          <form>
            <div className="row">
              <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                <div className="form-sub-div">
                  <label className="form-label">New Exam Name *</label>
                  <div className="form-elements">
                    <input
                      class="form-details"
                      type="text"
                      placeholder="Exam Name"
                      name="examName"
                      ref={register({
                        required: true,
                        validate: (value) =>
                          !getExamInfo()
                            ?.map((e) => e?.examName?.toUpperCase())
                            ?.includes(value.toUpperCase()),
                      })}
                    />
                    <div class="error-msg">
                      {errors?.examName?.type === "required" &&
                        "Exam Name is Required"}
                      {errors?.examName?.type === "validate" &&
                        "Exam Name is Already Exists"}
                    </div>
                  </div>
                </div>
                <div className="form-sub-div">
                  <label className="form-label">Exam Id *</label>
                  <div className="form-elements">
                    <input
                      class="form-details"
                      type="text"
                      placeholder="Exam Id"
                      name="examId"
                      value={id}
                      disabled
                    />
                  </div>
                </div>

                <div className="form-sub-div">
                  <label className="form-label">Exam Name *</label>
                  <div className="form-elements">
                    <input
                      class="form-details"
                      type="text"
                      placeholder="Exam Id"
                      name="examId"
                      value={examname}
                      disabled
                    />
                  </div>
                </div>

                <div class="form-sub-div">
                  <label class="form-label">Branch *</label>
                  <div class="form-elements">
                    <select
                      class="form-details"
                      name="branchId"
                      value={watch("branchId") || branchValue}
                      ref={register({
                        validate: (value) => value !== "",
                      })}
                      onChange={(e) => onChangeBranch(e.target.value)}
                    >
                      <option disabled value="">
                        Please Select Branch
                      </option>
                      {branches.map((ele) => (
                        <option key={ele?.branchId} value={ele?.branchId}>
                          {ele?.branchName}
                        </option>
                      ))}
                    </select>
                    <div class="error-msg">
                      {" "}
                      {(errors?.branchId?.type === "validate" ||
                        (watch("creationType")?.toUpperCase() === "MANUAL" &&
                          watch("branchId") === "")) &&
                        "Branch Name is Required"}{" "}
                    </div>
                  </div>
                </div>
                <div class="form-sub-div">
                  <label class="form-label">Batch *</label>
                  <div class="form-elements">
                    {batches && batches.length > 0 && (
                      <select
                        class="form-details"
                        name="batchId"
                        defaultValue={id ? getSelectedExamInfo().batchId : ""}
                        value={watch("batchId")}
                        ref={register({
                          validate: (value) => value !== "",
                        })}
                        onChange={(e) => onChangeBatch(e.target.value)}
                      >
                        <option disabled value="">
                          Please Select Batch
                        </option>
                        {batches.map((ele) => (
                          <option key={ele?.batchId} value={ele?.batchId}>
                            {ele?.batch}
                          </option>
                        ))}
                      </select>
                    )}
                    <div class="error-msg">
                      {" "}
                      {(errors?.batchId?.type === "validate" ||
                        (watch("creationType")?.toUpperCase() === "MANUAL" &&
                          watch("batchId") === "")) &&
                        "Batch Name is Required"}{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
